import { render, staticRenderFns } from "./EditionTable.vue?vue&type=template&id=19a64eaa&scoped=true&"
import script from "./EditionTable.vue?vue&type=script&lang=js&"
export * from "./EditionTable.vue?vue&type=script&lang=js&"
import style0 from "./EditionTable.vue?vue&type=style&index=0&id=19a64eaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a64eaa",
  null
  
)

export default component.exports